import _ from 'underscore';
import PropTypes from 'prop-types';
import React from 'react';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { getLocalStorage } from '@bingads-webui/storage';
import { withSiteMap, siteMapPropType } from '@bingads-webui-campaign-react/with-site-map';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { CreationHeader } from '../components/creation-header';


const styles = () => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
});

export function withCreationHeader(Component, headerCrumbs, backRouterId, isShowConfirmPopup, isBorderInsteadOfShadow) {
  const CreationHeaderHoC = (props) => {
    const { i18n, siteMap, classes } = props;
    const localStorage = getLocalStorage();
    let fromPathId = backRouterId;
    if (localStorage.supportsStorage()) {
      fromPathId = localStorage.get('fromPathId');
    }
    let crumbs = headerCrumbs;
    if (_.isUndefined(crumbs)) {
      const fromPage = _.findWhere(siteMap, { id: fromPathId });
      let fromPageName = '';
      if (fromPage && fromPage.name) {
        fromPageName = i18n.getString(_TL_(fromPage.name));
      }
      crumbs = [
        fromPageName || i18n.getString(_TL_('Campaigns')),
        i18n.getString(_TL_('Create Campaign'))];
    }
    return (
      <div className={classes.container}>
        <CreationHeader crumbs={crumbs} backRouterId={fromPathId} isShowConfirmPopup={isShowConfirmPopup} isBorderInsteadOfShadow={isBorderInsteadOfShadow} />
        <Component {...props} />
      </div>
    );
  };

  CreationHeaderHoC.propTypes = {
    i18n: PropTypes.shape({
      getString: PropTypes.func,
    }).isRequired,
    siteMap: siteMapPropType.isRequired,
    classes: PropTypes.shape({
      container: PropTypes.string.isRequired,
    }).isRequired,
  };

  return withDefaultStyles(withI18nConsumer(withSiteMap(CreationHeaderHoC)), styles);
}
